import ContactForm from "../components/ContactForm";

export default function Engineering() {
  return (
    <div className="p-6 max-w-5xl mx-auto">

      <h1 className="text-4xl font-bold mb-4">Engineering Services</h1>
	<p className="text-gray-600 mb-6">
  		We provide end-to-end engineering design services spanning CAD/CAM, product modeling,
  		and architecture solutions. Our focus is on delivering manufacturable, optimized,
  		and scalable designs aligned with real-world production constraints.
	</p>
      {/* Services */}
      <div className="grid md:grid-cols-2 gap-6 mb-10">

        <div className="p-6 bg-white shadow rounded">
          <h2 className="text-xl font-semibold">CAD Design</h2>
          <p className="text-gray-600 mt-2">
            2D and 3D design solutions for manufacturing and prototyping.
          </p>
        </div>

        <div className="p-6 bg-white shadow rounded">
          <h2 className="text-xl font-semibold">CAM Solutions</h2>
          <p className="text-gray-600 mt-2">
            Toolpath generation and optimization for CNC machining.
          </p>
        </div>

        <div className="p-6 bg-white shadow rounded">
          <h2 className="text-xl font-semibold">Architecture Design</h2>
          <p className="text-gray-600 mt-2">
            Structural and conceptual design for global clients.
          </p>
        </div>

        <div className="p-6 bg-white shadow rounded">
          <h2 className="text-xl font-semibold">Consultation</h2>
          <p className="text-gray-600 mt-2">
            Expert advice for design optimization and production workflows.
          </p>
        </div>

      </div>

<h2 className="text-2xl font-semibold mb-4">Our Engineering Workflow</h2>

<div className="grid md:grid-cols-4 gap-4 mb-8">

  <div className="p-4 bg-white shadow rounded">
    <h3 className="font-semibold">1. Requirement Analysis</h3>
    <p className="text-sm text-gray-600">Understand design intent and constraints</p>
  </div>

  <div className="p-4 bg-white shadow rounded">
    <h3 className="font-semibold">2. Design Modeling</h3>
    <p className="text-sm text-gray-600">Create CAD models and simulations</p>
  </div>

  <div className="p-4 bg-white shadow rounded">
    <h3 className="font-semibold">3. Optimization</h3>
    <p className="text-sm text-gray-600">Ensure manufacturability and efficiency</p>
  </div>

  <div className="p-4 bg-white shadow rounded">
    <h3 className="font-semibold">4. Delivery</h3>
    <p className="text-sm text-gray-600">Final files ready for production</p>
  </div>

</div>


<h2 className="text-2xl font-semibold mb-4">What You Get</h2>

<ul className="list-disc pl-6 text-gray-600 mb-8 space-y-2">
  <li>Production-ready design files</li>
  <li>Reduced manufacturing errors</li>
  <li>Optimized material usage</li>
  <li>Faster turnaround from design to production</li>
</ul>
      <h2 className="text-2xl font-semibold mb-4">Capabilities</h2>

	<ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
  		<li>2D/3D CAD modeling for manufacturing and prototyping</li>
  		<li>CAM toolpath generation and CNC optimization</li>
  		<li>Design validation for fabrication feasibility</li>
  		<li>Architecture-level design support for global clients</li>
	</ul>

      {/* CTA */}
      <div className="bg-gray-100 p-6 rounded">
        <h2 className="text-2xl font-semibold mb-2">Have a design requirement?</h2>
        <p className="text-gray-600 mb-4">
          Share your requirements and our team will get back to you.
        </p>

        <ContactForm />
      </div>

    </div>
  );
}
